var React = require('react');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step2;
var { $simpleSelect, $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var PasswordCriteriaChecklist = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/PasswordCriteriaChecklist.jsx');

class EmailAndPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationTimeout: null
        };
        this.bindFunctions();
    }

    componentWillUnmount() {
        if (this.state.validationTimeout) {
            clearTimeout(this.state.validationTimeout);
        }
    }

    componentDidMount() {
        this.props.updateStepState('showPassword', false);
        this.props.updateStepState('password', '');
        this.props.updateStepState('showPassCriteria', false);
        this.props.updateStepState('tooltipPosition', 'right');

        if (memberTypeChecker.emailLocationIsHome(this.props.appState.appType)) {
            this.props.updateStepState('emailLocation', 'HOME');
        } else {
            this.props.updateStepState('emailLocation', 'BUSINESS');
        }
    }

    bindFunctions() {
        this.handleInputChange = this.handleInputChange.bind(this);
        this.toggleShowPassword = this.toggleShowPassword.bind(this);
        this.handleInputOnBlurEvent = this.handleInputOnBlurEvent.bind(this);
        this.handlePasswordBlur = this.handlePasswordBlur.bind(this);
        this.handleValidationChange = this.handleValidationChange.bind(this);
    }

    toggleShowPassword() {
        this.props.updateStepState('showPassword', !this.props.stepState.showPassword);
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    handleInputOnBlurEvent(event) {
        this.props.checkIfEmailExists(event);
        this.props.checkUserExistingModal();
    }

    handlePasswordBlur(event) {
        this.props.checkUserExistingModal();
        this.props.updateStepState('showPassCriteria', false);
    }

    handleValidationChange(valid) {
        // Clear existing timeout
        if (this.state.validationTimeout) {
            clearTimeout(this.state.validationTimeout);
        }

        // Set new timeout to debounce the validation
        const timeoutId = setTimeout(() => {
            // Only update if the component is still mounted and value has changed
            if (this.props.stepState && this.props.stepState.validPassword !== valid) {
                this.props.updateStepState('validPassword', valid);
            }
        }, 100);

        this.setState({ validationTimeout: timeoutId });
    }

    render() {
        if (this.props.appState.userLoggedIn) {
            return null;
        }

        const emailExistsWarning = this.props.emailAccountExists ?
            <span className={"warning"}>
                {labels.step2.accountAlreadyExists}
                <a href={labels.step2.loginUrl}>{labels.step2.loginToContinue}</a>
            </span> : null;

        return <div className={"email-password-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step2.emailPassword}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <div className={"field-wrap"}>
                                <label>{labels.step2.email}</label>
                                <$input
                                    name="email"
                                    value={this.props.stepState.email}
                                    onChange={this.props.handleEmailInputChange}
                                    validations={[validationFunctions.required, validationFunctions.email]}
                                    onBlur={this.handleInputOnBlurEvent}
                                />
                                {emailExistsWarning}
                            </div>
                            <div className={"field-wrap"}>
                                <label>{labels.step2.password}</label>
                                <span className={"get-info"} onClick={() => { return this.props.showInfoModal('password') }}>
                                    {this.props.getInfoModalContent("password").infoIconLabel}
                                </span>
                                <PasswordCriteriaChecklist
                                    asTooltip
                                    showPasswordMatch={false}
                                    tooltipPosition={this.props.stepState.tooltipPosition}
                                    open={this.props.stepState.showPassCriteria}
                                    password={this.props.stepState.password}
                                    onValidationChange={this.handleValidationChange}
                                >
                                    <input
                                        name="password"
                                        type={this.props.stepState.showPassword ? "text" : "password"}
                                        value={this.props.stepState.password}
                                        onBlur={this.handlePasswordBlur}
                                        onChange={this.handleInputChange}
                                        onFocus={() => this.props.updateStepState('showPassCriteria', true)}
                                        required
                                        data-private
                                    />
                                </PasswordCriteriaChecklist>
                                <div className={"show-password-wrapper"}>
                                    <label htmlFor={"showPassword"}>{labels.step2.showPassword}</label>
                                    <input
                                        className={"show-password"}
                                        type="checkbox"
                                        id={"showPassword"}
                                        defaultChecked={this.props.stepState.showPassword}
                                        onClick={this.toggleShowPassword}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = EmailAndPassword;